<div [formGroup]="formGroup" class="pure-g">
  <!-- Shop Active -->
  <div class="pure-u-1 pure-u-md-6-24 p-r-16 p-b-16">
    <div class="inline-switch">
      <mc-switch
        ngDefaultControl
        formControlName="shopActive"
        [checked]="formGroup.get('shopActive')?.value || false"
        label="Shop Active"
        name="shopActive"
        fit="small">
      </mc-switch>
    </div>
  </div>

  <!-- Decentralised -->
  <div class="pure-u-1 pure-u-md-6-24 p-r-16 p-b-16">
    <div class="inline-switch">
      <mc-switch
        ngDefaultControl
        formControlName="decentralised"
        [checked]="formGroup.get('decentralised')?.value || false"
        label="Decentralised"
        name="decentralised"
        fit="small">
      </mc-switch>
    </div>
  </div>

  <!-- Preparation Time -->
  <div class="pure-u-1 pure-u-md-6-24 p-r-16 p-b-16">
    <div class="inline-switch">
      <mc-switch
        ngDefaultControl
        formControlName="preparationTime"
        [checked]="formGroup.get('preparationTime')?.value || false"
        label="Preparation Time"
        name="preparationTime"
        fit="small">
      </mc-switch>
    </div>
  </div>

  <!-- Mode 49 Flag -->
  <div class="pure-u-1 pure-u-md-6-24 p-b-16">
    <div class="inline-switch">
      <mc-switch
        ngDefaultControl
        formControlName="mode49Flag"
        [checked]="formGroup.get('mode49Flag')?.value || false"
        label="Mode 49 Flag"
        name="mode49Flag"
        fit="small">
      </mc-switch>
    </div>
  </div>
</div>
